// extracted by mini-css-extract-plugin
export default {"span":"ptGHli","disabled":"atPMux"};